import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import * as ROUTES from '../constants';

export function IsUserRedirect({ user, loggedInPath, children, ...rest }) {
  return (
    <Route
      {...rest}
      render={() => {
        if (!user) {
          return children;
        }

        if (user) {
          return <Redirect to={{ pathname: loggedInPath }} />;
        }

        return null;
      }}
    />
  );
}

export function ProtectedRoute({ user, children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (user) return children;

        if (!user)
          return (
            <Redirect
              to={{ pathname: ROUTES.HOME, state: { from: location } }}
            />
          );
        return null;
      }}
    />
  );
}
